var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.$t("receivablePayable.AddANote"),
        visible: _vm.showAddNotes,
        width: "50%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showAddNotes = $event
        },
        close: function ($event) {
          _vm.remarks = ""
        },
      },
    },
    [
      _c("el-input", {
        attrs: { rows: 5, type: "textarea" },
        model: {
          value: _vm.remarks,
          callback: function ($$v) {
            _vm.remarks = $$v
          },
          expression: "remarks",
        },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.colsDialog } }, [
            _vm._v(_vm._s(_vm.$t("basicData.Cancel"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveRemarks } },
            [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }